import type { NotificationsViewModel } from "@bundle/core";
import { useT } from "../i18n/I18nProvider.tsx";
import { useViewModel } from "../hooks/index.ts";
import { Button, Icon, Stack, Surface, Text } from "../primitives/index.ts";

/**
 * "Turn on desktop notifications", above the profile row, while they are off and the person hasn't said "Not now"
 * (NotificationsViewModel `offer`, desktop only). "Turn on" asks for the permission from the click.
 */
export function NotificationsOffer({ notifications }: { notifications: NotificationsViewModel }) {
  const t = useT();
  const state = useViewModel(notifications);
  if (state.offer !== true) return null;
  return (
    <Stack padding="2" testID="notifications-offer">
      <Surface material="elevated" padding="3" radius="lg">
        <Stack gap="3">
          <Stack direction="horizontal" gap="2" align="start">
            <Icon name="bell" size="icon.sm" color="accent.text" />
            <Stack grow gap="0.5">
              <Text variant="footnote" weight="semibold">
                {t("notifications.offer.title")}
              </Text>
              <Text variant="caption" color="text.secondary">
                {t("notifications.offer.body")}
              </Text>
            </Stack>
          </Stack>
          <Stack direction="horizontal" gap="2" justify="end">
            <Button label={t("notifications.offer.dismiss")} variant="ghost" size="sm" onPress={() => notifications.dismissOffer()} testID="notifications-offer-dismiss" />
            <Button label={t("notifications.offer.enable")} variant="primary" size="sm" loading={state.busy} onPress={() => void notifications.enable()} testID="notifications-offer-enable" />
          </Stack>
        </Stack>
      </Surface>
    </Stack>
  );
}
